import React from 'react'
import classes from './Topic.module.css'
import { SiFireship } from "react-icons/si";
import {Link} from 'react-router-dom'


const Topic = ({topic,category}) => {
  return (
    <div className={classes.topic_container}>
    <div className={classes.sub_container}>
      <div className={classes.text}>
      {topic == 'Top' && <SiFireship className={classes.icon}/>}
      {topic}
      </div>
      {
        topic !== 'Top' && topic !== 'Similar Videos' && 
        <Link to={`/Category/${category}`}>
        <button className={classes.btn}>
      See All
      </button>
      </Link>
      }
      </div>
    </div>
  )
}

export default Topic
